import { render, staticRenderFns } from "./AIHistoryListItem.vue?vue&type=template&id=06080cde&"
import script from "./AIHistoryListItem.vue?vue&type=script&lang=js&"
export * from "./AIHistoryListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports